export default class LocalStorage {
	public constructor(name) {
		this._localStorageName = name
	}

	public set(value): void {
		try {
			if (typeof window !== 'undefined') {
				const string = JSON.stringify(value)
				window.localStorage.setItem(this._localStorageName, string)
			}
		} catch(e) {}
	}

	public get get(): any {
		try {
			if (typeof window !== 'undefined') {
				const string = window.localStorage.getItem(this._localStorageName)
				const data = JSON.parse(string)
				return data
			}
		} catch(e) {}
	}
}